import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { IStage } from '../components/apia/execution/scheduler/mini/SchedulerMini';
import { TScheduleResult } from '../components/apia/execution/scheduler/types';

export interface ISelectedDay {
  hour?: string;
  day?: string;
  mondayWeek?: string;
  dayNumber?: number;
  morningOrAfternoonSelected?: number | null;
}
export interface ISchedulerStore {
  data?: TScheduleResult;
  isLoading?: string;
  url?: string;
  showDisponibility?: string;
  showAttributes?: string;
  overassign?: string;
  selectedCell?: string | null;
  focusStage?: string;
  stageList?: string[];
  labelSelectedDay?: {
    hour: string;
    day?: string;
  };
  selectedDay?: ISelectedDay;
  stageData: IStage[];
  isStageMounted: Record<string, boolean>;
}

const schedulerSlice = createSlice({
  name: 'schedulerSlice',
  initialState: {
    stageData: [],
    isStageMounted: { daysList: true },
  } as ISchedulerStore,

  reducers: {
    setState(state, { payload }: PayloadAction<Partial<ISchedulerStore>>) {
      Object.entries(payload).forEach(([key, value]) => {
        (state[key as keyof typeof state] as unknown) = value;
      });
    },
    setHour(state, { payload }: PayloadAction<{ newHour: string }>) {
      if (!state.selectedDay) state.selectedDay = {};
      state.selectedDay.hour = payload.newHour;
    },
    setDay(state, { payload }: PayloadAction<ISelectedDay>) {
      if (!state.selectedDay) state.selectedDay = {};
      state.selectedDay = { ...state.selectedDay, ...payload };
    },
    setData(state, { payload }: PayloadAction<TScheduleResult>) {
      state.data = payload;
    },
    setStage(
      state,
      { payload }: PayloadAction<{ index: number; stage: IStage }>,
    ) {
      if (!state.stageData) state.stageData = [];
      state.stageData[payload.index] =
        payload.stage as unknown as Draft<IStage>;
      state.stageData.splice(payload.index + 1);
    },
    setStageMounted(
      state,
      { payload }: PayloadAction<{ stageName: string; isMounted: boolean }>,
    ) {
      if (payload.isMounted !== undefined) {
        state.isStageMounted[payload.stageName] = payload.isMounted;
      }
      // else {
      //   state.isStageMounted[payload.stageName] =
      //     !state.isStageMounted[payload.stageName];
      // }
    },
  },
});

export const schedulerActions = schedulerSlice.actions;
export default schedulerSlice.reducer;
